$bp-breakpoint-xs: 0;
$bp-breakpoint-s: 414px;
$bp-breakpoint-m: 768px;
$bp-breakpoint-l: 960px;
$bp-breakpoint-xl: 1120px;

$border-radius: 4px;

:host {
    font-family: 'Fira Sans', sans-serif;
    box-sizing: border-box;
    display: block;
    width: fit-content;
    font-size: 16px;
    margin: 0;
    position: relative;
    padding-top: 3.5rem;

    .wrapper {
        display: flex;

        .counter {
            box-sizing: border-box;
            background-color: #20487B;
            font-size: 2rem;
            color: #fff;
            text-indent: 0;
            border-radius: $border-radius;
            height: 3.2rem;
            display: inline-block;
            margin-right: 10px;
            text-align: center;
            padding: 0.1rem 1.2rem;
            line-height: 3.1rem;
            vertical-align: middle;
        }

        button {
            appearance: none;
            all: unset;
            cursor: pointer;
            padding-left: 10px;
            display: flex;
            font-size: 2.6rem;
            line-height: 3.2rem;
            vertical-align: middle;

            &:focus-visible {
                text-decoration: underline;
            }

            c-icon {
                height: 24px;
                margin-left: 20px;
                color: #356799;
                margin-top: 5px;
            }
        }
        
    }

    .flyout {
        position: relative;
        padding-bottom: 3rem;
        margin-top: 1rem;

        ol {
            min-width: 100%;
            list-style: none;
            counter-reset: link-counter;
            padding: 0;
            margin: 0;
            background-color: white;
            z-index: 4;
            position: absolute;
            border: 1px solid #356799;
            border-radius: $border-radius;
            overflow: hidden;

            @include bp($bp-breakpoint-m) {
                position: relative;
            }

            li {
                border-bottom: 1px solid #356799;

                &:last-child {
                    border-bottom: none;
                }

                a {
                    display: block;
                    counter-increment: link-counter;
                    text-decoration: none;
                    color: #222222;
                    padding: 1.675rem 3rem 1.675rem 5rem;

                    &:hover {
                        background-color: #F0F4F7;
                    }

                    &:focus {
                        outline: none;
                        background-color: #F0F4F7;
                    }

                    &:focus-visible {
                        text-decoration: underline;
                    }

                    &::before {
                        content: counter(link-counter) " ";
                        color: #356799;
                        width: 30px;
                        font-weight: 700;
                        position: absolute;
                        left: 1.1rem;
                        text-align: center;
                    }
                }

            }
        }

    }

    .visually-hidden {
        clip: rect(0 0 0 0);
        clip-path: inset(50%);
        height: 1px;
        overflow: hidden;
        position: absolute;
        white-space: nowrap;
        width: 1px;
    }


}